import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Component, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/user/auth.service';
import { ToastComponent } from '../../shared/toast/toast.component';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DashboardCategoriesModel } from '../../core/models/dashboard-categories.model';
import { CustomersService } from '../../core/services/customer/customers.service';
import { UserSessionModel } from '../../core/models/user/current-user.model';
import { CurrentUserService } from '../../core/services/user/current-user.service';
import { CookieService } from '../../core/services/cookie.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastComponent,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  categories: DashboardCategoriesModel[] = [];
  currentUser: UserSessionModel | null = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
  }
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  forgotPasswordForm = {
    email: '',
  };
  sendResetCode: boolean = false;
  showToast: boolean = false;
  toastMessage: string = '';
  toastType: 'success' | 'error' | 'warning' = 'success';
  currentYear: number = new Date().getFullYear();
  ngOnInit() {}

  submitForgotPassword(e: Event): void {
    e.preventDefault();
    this.authService.forgotPassword(this.forgotPasswordForm).subscribe({
      next: async () => {
        this.displayToast(
          true,
          this.translate.instant('forgotPassword.eMailSendSuccessful'),
          'success'
        );

        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      },
    });
  }

  displayToast(show: boolean, message: string, type: string | any): void {
    this.showToast = show;
    this.toastMessage = message;
    this.toastType = type;
  }
}
